import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthContext'
import {
  NO_IMAGE_SRC,
  getInstituteStampPathFromRecord,
  resolveInstituteLogoSrc,
  resolveInstituteStampSrc,
} from '../utils/instituteBranding'

const InstituteSelectionModal = ({ onClose, show }) => {
  const { token, roles, user_type } = useAuth()
  const navigate = useNavigate()
  const [selectInstitute, setSelectInstitute] = useState('') // Initialize as an empty string
  const [institutes, setInstitutes] = useState([]) // Initialize as an empty array to avoid map errors
  const [openModal, setOpenModal] = useState(false)
  
  // Handle Cancel button - always redirect to LoginSignup and clear any institute selection
  const handleCancel = (e) => {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    // console.log('Cancel button clicked. Redirecting to LoginSignup.')
    
    // Clear institute_id cookie to ensure no access to Dashboard
    Cookies.remove('institute_id')
    Cookies.remove('roles')
    Cookies.remove('user_type')
    Cookies.remove('user')
    Cookies.remove('name')
    Cookies.remove('address')
    Cookies.remove('pincode')
    Cookies.remove('session_name')
    Cookies.remove('institute_logo')
    Cookies.remove('stamp_url_img')
    Cookies.remove('institute_stamp')
    // Clear sessionStorage flag to prevent stale cookie access
    sessionStorage.removeItem('institute_confirmed')
    sessionStorage.removeItem('institute_confirmed_timestamp')
    // console.log('Cookies and sessionStorage cleared. Current URL:', window.location.href)
    
    // Force immediate navigation using window.location.href (same method used in Sidenavbar)
    // This bypasses React Router completely and forces a full page reload
    // Using href instead of replace to match the pattern used elsewhere in the codebase
    try {
      window.location.href = '/LoginSignup'
      // console.log('Navigation command executed')
    } catch (error) {
      console.error('Navigation error:', error)
      // Fallback: try using window.location.replace
      window.location.replace('/LoginSignup')
    }
  }

  useEffect(() => {
  // console.log("Roles in authContext ->", roles);
  // console.log("User_type in authContext ->", user_type);
}, [roles, user_type]);

  useEffect(() => {
    ApiEndpoints.getAllInstitutesAssinged()
      .then((res) => {
        // console.log("Institutes: ", res.data.data)
        setInstitutes(res.data.data) // Set the list of institutes
      })
      .catch((error) => {
        toast.error('Failed to fetch institutes.')
      })
  }, [])

  const handleSelect = (e) => {
    setSelectInstitute(e.target.value)
  }

  const selectedInstitute = institutes.find(
    (inst) => inst?.institute_id?.toString() === selectInstitute?.toString(),
  )
  const previewLogoSrc = selectedInstitute
    ? resolveInstituteLogoSrc(selectedInstitute.institute_logo || 'no_image.png')
    : NO_IMAGE_SRC

const handleNonAdmin = async (institute_id) => {
  try {

    const response = await fetch(
      BASE_URL + `/user/role/${institute_id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const result = await response.json();
    console.log("Non-admin role API result:", result);

    if (!response.ok) {
      toast.error(result.message || "Failed to load role details");
      return;
    }

    // Extract roles from API response
    const roles = result?.roles || [];

    // Store roles in cookie (optional)
    Cookies.set("user_roles", JSON.stringify(roles), { expires: 7 });

    if (roles.includes("accountant")) {
      toast.success("Welcome Accountant!");
      // navigate("/AssignClass");
      return;
    }

    // Handle teacher
    if (roles.includes("teacher")) {
      toast.success("Welcome Teacher!");
      // navigate("/AssignClass");
      return;
    }

    if(roles.includes("admin")){
     toast.success("Welcome Admin!")
    //  navigate("/Dashboard");
     return;
    }

    // Default case if no role matched
    toast.success("Welcome!");
    // navigate("/Dashboard");

  } catch (error) {
    console.error(error);
    toast.error("Error while fetching role details.");
  }
};

  const handleConfirm = async () => {
    // console.log('institutes:', institutes) // ✅ Debugging log

    if (!selectInstitute) {
      toast.error('Please select an institute.')
      return
    }

    // Match using `institute_id` instead of `id`
    const institute = institutes.find(
      (inst) => inst?.institute_id?.toString() === selectInstitute?.toString(),
    )

    if (!institute) {
      toast.error('Invalid Institute Selection.')
      return
    }

    // Store in Cookies (use correct API field names)
    Cookies.set('institute_id', institute.institute_id, { expires: 7 })
    Cookies.set('name', institute.name, { expires: 7 })
    Cookies.set('address', institute.address, { expires: 7 })
    Cookies.set('pincode', institute?.pincode || '', { expires: 7 })
    Cookies.set('session_name', institute?.active_session?.session_name || '', { expires: 7 })
    const resolvedInstituteType = String(
      institute?.institute_type || institute?.type || '',
    )
      .trim()
      .toLowerCase()
    if (resolvedInstituteType) {
      Cookies.set('institute_type', resolvedInstituteType, { expires: 7 })
      try {
        const rawUser = Cookies.get('user')
        if (rawUser) {
          const userData = JSON.parse(rawUser)
          userData.institute_type = resolvedInstituteType
          Cookies.set('user', JSON.stringify(userData))
        }
      } catch {
        /* ignore */
      }
    }
    if (institute?.active_session?.id != null) {
      Cookies.set('academic_session_id', String(institute.active_session.id), { expires: 7 })
    } else {
      Cookies.remove('academic_session_id')
    }
    if (institute?.institute_logo) {
      Cookies.set(
        'institute_logo',
        resolveInstituteLogoSrc(institute.institute_logo),
        { expires: 7 },
      )
    } else {
      Cookies.remove('institute_logo')
    }
    const stampPath = getInstituteStampPathFromRecord(institute)
    Cookies.set('institute_stamp', resolveInstituteStampSrc(stampPath), {
      expires: 7,
    })
    Cookies.remove('stamp_url_img')

    // Set sessionStorage flag to track that institute was confirmed in this session
    // This prevents stale cookies from previous sessions allowing Dashboard access
    sessionStorage.setItem('institute_confirmed', 'true')
    sessionStorage.setItem('institute_confirmed_timestamp', Date.now().toString())

  //   const loginUserType = Cookies.get('user_type')
  //   const loginUserRole = Cookies.get('user_roles')
  //   console.log("Logged in user type:", loginUserType);
  //   console.log("Logged in user roles from cookie:", loginUserRole);
    
  //   if (loginUserType !== "admin") {
  //   console.log("Running NON-admin from LOGIN...");
  //   await handleNonAdmin(institute.institute_id);
  //   onClose();
  //   return;
  // }

    // 👉 For ADMIN use existing flow
    // console.log("Running ADMIN existing flow...");
    
    // Full reload so AuthContext picks up institute_type written to the user cookie.
    window.location.assign('/Dashboard')
  }

  return (
    <Modal 
      show={true} 
      onHide={handleCancel}
      centered 
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{ backgroundColor: '#223843' }}>
        <img
          src={previewLogoSrc}
          alt=""
          style={{
            width: 36,
            height: 36,
            marginRight: '10px',
            objectFit: 'contain',
            borderRadius: '50%',
            border: '2px solid #dee2e6',
            background: '#f8f9fa',
          }}
        />
        <Modal.Title>Select Institute</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Select Institute</Form.Label>
            <Form.Select onChange={handleSelect} value={selectInstitute}>
              <option value="">Select</option>
              {institutes.length > 0 ? (
                institutes.map((inst) => (
                  <option key={inst.institute_id} value={inst.institute_id}>
                    {inst.name}
                  </option>
                ))
              ) : (
                <option disabled>Loading...</option>
              )}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
          type="button"
          variant="secondary" 
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button variant="white" style={{ backgroundColor: '#223843', color: 'white' }} onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default InstituteSelectionModal
